import gql from 'graphql-tag';

export const externalShippingAddressDetails = gql`
  fragment externalShippingAddressDetails on ExternalShippingAddress {
    id
    name
    date_of_birth
    email_address
    phone_number
    address_line_1
    address_line_2
    city
    post_code
    state
    country {
      id
      name
      iso
      iso3
    }
  }
`;
